import axios from 'axios';
// import React from 'react';
// import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { AuhMethods } from '../../../services/auth';
import { CurrentAuthMethod } from '../../../@jumbo/constants/AppConstants';
// export default axios.create({
//   baseURL: `https://logwatch-api.myreports.online/`, //YOUR_API_URL HERE
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const customAxios = axios.create({
  // baseURL: `http://g-axon.work/jwtauth/api/`, //YOUR_API_URL HERE
  baseURL: process.env.REACT_APP_API_URL, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});
export const customFormAxios = axios.create({
  // baseURL: `http://g-axon.work/jwtauth/api/`, //YOUR_API_URL HERE
  baseURL: process.env.REACT_APP_API_URL, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export default customAxios;
